<template>
  <div class="signUpTableList_page">
    <el-table
      :data="data"
      :header-cell-style="setColumnDataColor"
      :cell-style="setCellStyle"
      style="width: 100%"
      v-loading="loadingTrue"
    >
      <template slot="empty">
        <img src="@/static/img/cailiao.png" alt />
        <p class="noText" style="color: #000; fontsize: 16px">暂无数据</p>
      </template>
      <el-table-column
        prop="contact"
        label="联系人"
        show-overflow-tooltip
        width="180"
      ></el-table-column>
      <el-table-column
        label="联系电话"
        prop="contactPhone"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.contactPhone ? starPhone(scope.row.contactPhone) : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="拥有工种"
        prop="workTypeName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="工作人数"
        prop="constructionNumber"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{
            scope.row.constructionNumber
              ? scope.row.constructionNumber + "人"
              : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="用工专业"
        prop="categoryName"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
          >{{ scope.row.industryName
          }}{{
            scope.row.categoryName ? "/" + scope.row.categoryName : ""
          }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="addressAll"
        label="所在地区"
        show-overflow-tooltip
        width="180"
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  setColumnDataColor,
  setCellStyle
} from '@/views/Home/components/style.js'
export default {
  data () {
    return {
      setColumnDataColor,
      setCellStyle
    }
  },
  props: {
    data: {
      type: Array
    },
    loadingTrue: {
      type: Boolean
    }
  },
  components: {},

  methods: {
    // 隐藏号码中间4位数
    starPhone (phoneNum) {
      let str = String(phoneNum)
      return str.substr(0, 3) + '****' + str.substr(7)
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.signUpTableList_page {
}
/deep/.el-table{
  border: 1px solid #E4E7ED;
  border-bottom: none;
}

</style>
